<script lang="ts">
  import { type Snippet } from "svelte";
  import MagnifyingGlass from "~icons/ph/magnifying-glass";
  import WaitButton from "../WaitButton.svelte";
  import type { HTMLInputAttributes } from "svelte/elements";

  let {
    inputClass = "",
    buttonClass = "",
    name,
    placeholder,
    disabled,
    required,
    autocomplete = undefined,
    value = $bindable(""),
    label = "Search",
    search = undefined,
    validator = (_v)=>""
  } : {
    inputClass? : string;
    buttonClass? : string;
    name? : string;
    placeholder? : string;
    disabled? : boolean;
    required? : boolean;
    autocomplete? : HTMLInputAttributes["autocomplete"];
    value? : string;
    label? : string | Snippet;
    search? : (s: string)=>any;
    validator? : (s: string)=>string;
  } = $props()

  let input = $state<HTMLInputElement>()

  function doSearch(event: MouseEvent){
    const cv = validator(value)
    if(cv) {
      input?.setCustomValidity(cv)
      input?.reportValidity()
      event.preventDefault()
      return;
    }
    if(!search) return;
    event.preventDefault();
    return search(value)
  }

  export function focus() { input?.focus() }

  let buttonType = $state("button")
</script>
<div class="join">
  <label
    class="join-item w-3/4 input input-bordered border-r-0 focus-within:outline-none focus-within:border-blue-600
           flex items-center gap-2"
  >
    <MagnifyingGlass class="w-5 h-5 text-base-content/50"/>
    <input
      bind:this={input} bind:value
      oninput={(_e)=>input?.setCustomValidity("")}
      onfocus={(_e)=>buttonType = "submit"}
      onblur={(_e)=>{ buttonType = "button"; input?.setCustomValidity("") }}
      class="grow {inputClass}" {placeholder} {name} {disabled} {required} {autocomplete}
    >
  </label>
  <WaitButton type={buttonType} class="btn {buttonClass} join-item w-1/4" onclick={doSearch} {disabled}>
    {#if typeof label === "string"}
      {label}
    {:else}
      {@render label?.()}
    {/if}
  </WaitButton>
</div>
